export default __webpack_public_path__ + "static/media/servimax-ca-all.b5a0303b.png";